export { BuildingInformationSection as default } from './BuildingInformationSection';
